import { atom } from "jotai";
import type { OverviewPeriod } from "../types";

/**
 * Period the overview counts are scoped to. Values match the `filter` query
 * param accepted by the home screen dashboard API.
 */
export const overviewPeriodAtom = atom<OverviewPeriod>("all");
